"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[462],{

/***/ 81572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EC": function() { return /* binding */ fetchMyBundlePasses; },
/* harmony export */   "OO": function() { return /* binding */ fetchPaymentItemDetail; },
/* harmony export */   "U4": function() { return /* binding */ fetchPromotion; },
/* harmony export */   "X7": function() { return /* binding */ fetchAchievmentPage; },
/* harmony export */   "eB": function() { return /* binding */ postAchievement; },
/* harmony export */   "hZ": function() { return /* binding */ fetchPassItemDetail; },
/* harmony export */   "mK": function() { return /* binding */ verifyPaymentItem; },
/* harmony export */   "nw": function() { return /* binding */ fetchMySubscriptions; },
/* harmony export */   "q0": function() { return /* binding */ fetchStoreBundlePassItems; },
/* harmony export */   "rH": function() { return /* binding */ fetchPaymentItems; },
/* harmony export */   "yL": function() { return /* binding */ postPromotion; },
/* harmony export */   "zJ": function() { return /* binding */ fetchRecommendPaymentItems; }
/* harmony export */ });
/* unused harmony exports fetchStoreBundlePassItemDetail, fetchSubscriptionDetail */
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39322);
/* harmony import */ var _utils_misc__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45874);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};


var fetchRecommendPaymentItems = function() {
    var _ref = _asyncToGenerator(function(vendor) {
        var data, error;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/store/goods-items/recommend".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_1__/* .toQueryString */ .UK)({
                            vendor: vendor
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchRecommendPaymentItems(vendor) {
        return _ref.apply(this, arguments);
    };
}();
var verifyPaymentItem = function() {
    var _ref = _asyncToGenerator(function(paymentId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.post */ .hi.post("/store/goods-items/".concat(paymentId, "/check-purchasable/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function verifyPaymentItem(paymentId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchPaymentItems = function() {
    var _ref = _asyncToGenerator(function(query) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/store/goods-items/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_1__/* .toQueryString */ .UK)(_objectSpread({}, query))))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchPaymentItems(query) {
        return _ref.apply(this, arguments);
    };
}();
var fetchPaymentItemDetail = function() {
    var _ref = _asyncToGenerator(function(paymentItemId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/store/goods-items/".concat(paymentItemId))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchPaymentItemDetail(paymentItemId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchPromotion = function() {
    var _ref = _asyncToGenerator(function(id) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/store/promotions/".concat(id))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchPromotion(id) {
        return _ref.apply(this, arguments);
    };
}();
var postPromotion = function() {
    var _ref = _asyncToGenerator(function() {
        var promotionId, data;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    promotionId = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 1;
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.post */ .hi.post("/store/promotions/".concat(promotionId, "/histories/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function postPromotion() {
        return _ref.apply(this, arguments);
    };
}();
var fetchPassItemDetail = function() {
    var _ref = _asyncToGenerator(function(paymentItemId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/store/bundle-passes/".concat(paymentItemId, "/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchPassItemDetail(paymentItemId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchMyBundlePasses = function() {
    var _ref = _asyncToGenerator(function(isInProgress, isExpired, bundlePassType) {
        var data, err;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/store/my-bundle-passes/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_1__/* .toQueryString */ .UK)(_objectSpread({}, isInProgress && {
                            isInProgress: isInProgress
                        }, isExpired && {
                            isExpired: isExpired
                        }, bundlePassType && {
                            bundlePassType: bundlePassType
                        }))))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
                case 2:
                    err = _state.sent();
                    console.log(err);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchMyBundlePasses(isInProgress, isExpired, bundlePassType) {
        return _ref.apply(this, arguments);
    };
}();
var fetchStoreBundlePassItems = function() {
    var _ref = _asyncToGenerator(function(param) {
        var bundlePassType, vendor, data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    bundlePassType = param.bundlePassType, vendor = param.vendor;
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/store/bundle-pass-payment-items/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_1__/* .toQueryString */ .UK)(_objectSpread({}, bundlePassType && {
                            bundlePassType: bundlePassType
                        }, vendor && {
                            vendor: vendor
                        }))))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchStoreBundlePassItems(_) {
        return _ref.apply(this, arguments);
    };
}();
var fetchStoreBundlePassItemDetail = function() {
    var _ref = _asyncToGenerator(function(paymentItemId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/store/bundle-pass-payment-items/".concat(paymentItemId, "/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchStoreBundlePassItemDetail(paymentItemId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchSubscriptionDetail = function() {
    var _ref = _asyncToGenerator(function(paymentItemId) {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/store/subscriptions/".concat(paymentItemId, "/"))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchSubscriptionDetail(paymentItemId) {
        return _ref.apply(this, arguments);
    };
}();
var fetchMySubscriptions = function() {
    var _ref = _asyncToGenerator(function() {
        var page, perPage, data;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    page = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : 1, perPage = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 20;
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/store/my-subscriptions/".concat((0,_utils_misc__WEBPACK_IMPORTED_MODULE_1__/* .toQueryString */ .UK)({
                            page: page,
                            perPage: perPage
                        })))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchMySubscriptions() {
        return _ref.apply(this, arguments);
    };
}();
var fetchAchievmentPage = function() {
    var _ref = _asyncToGenerator(function() {
        var data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.get */ .hi.get("/achievements_page/")
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchAchievmentPage() {
        return _ref.apply(this, arguments);
    };
}();
var postAchievement = function() {
    var _ref = _asyncToGenerator(function(param) {
        var achievementId, itemId, requirement, key, requirementKey, data;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    achievementId = param.achievementId, itemId = param.itemId, requirement = param.requirement, key = param.key;
                    requirementKey = key ? key : "unit_id";
                    return [
                        4,
                        ___WEBPACK_IMPORTED_MODULE_0__/* .api.post */ .hi.post("/achievements/".concat(achievementId, "/items/").concat(itemId, "/purchase/"), {
                            requirement_completion_extra: _defineProperty({}, requirementKey, requirement)
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function postAchievement(_) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 41785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ BROADCAST_CHANNEL; },
/* harmony export */   "t": function() { return /* binding */ useBroadcastChannel; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var broadcast_channel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38718);
/* harmony import */ var semver__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64912);
/* harmony import */ var semver__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(semver__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39854);
/* harmony import */ var _contexts_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30259);
/* harmony import */ var _utils_misc__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45874);






var BROADCAST_CHANNEL = {
    CHARACTER_UPDATE: "character_update",
    CHARACTER_DELETE: "character_delete",
    VERIFICATION_EVENT_CONFIRM: "verification_event_confirm",
    PURCHASE_DAILY_FREE_PASS: "purchase_daily_free_pass"
};
function useBroadcastChannel(channelName, onMessage, options) {
    var ref = (0,_contexts_global__WEBPACK_IMPORTED_MODULE_3__/* .useGlobalContext */ .bN)(), platform = ref.platform, os = ref.os;
    var isUnderVersion = platform === _constants__WEBPACK_IMPORTED_MODULE_2__/* .Platform.ios */ .t4.ios && os && !semver__WEBPACK_IMPORTED_MODULE_1___default().gte((0,_utils_misc__WEBPACK_IMPORTED_MODULE_4__/* .normalizeVersion */ .Kt)(os), "15.4.0");
    var broadcastChannelRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var onMessageRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var handlePostMessage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(message) {
        if (platform === _constants__WEBPACK_IMPORTED_MODULE_2__/* .Platform.ios */ .t4.ios && isUnderVersion) {
            return;
        }
        if (broadcastChannelRef.current) {
            broadcastChannelRef.current.postMessage(message);
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (platform === _constants__WEBPACK_IMPORTED_MODULE_2__/* .Platform.ios */ .t4.ios && isUnderVersion) {
            return;
        }
        if (onMessage) {
            onMessageRef.current = onMessage;
        }
    }, [
        onMessage
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (platform === _constants__WEBPACK_IMPORTED_MODULE_2__/* .Platform.ios */ .t4.ios && isUnderVersion) {
            return;
        }
        var mounted = true;
        var channel = new broadcast_channel__WEBPACK_IMPORTED_MODULE_5__/* .BroadcastChannel */ .g0(channelName, options);
        var handleMessage = function(message) {
            var ref;
            if (!mounted) {
                return;
            }
            (ref = onMessageRef.current) === null || ref === void 0 ? void 0 : ref.call(onMessageRef, message);
        };
        channel.onmessage = handleMessage;
        broadcastChannelRef.current = channel;
        return function() {
            mounted = false;
            broadcastChannelRef.current = null;
            channel.close();
        };
    }, [
        channelName,
        options
    ]);
    return {
        postChannelMessage: handlePostMessage
    };
}


/***/ }),

/***/ 30462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useBundlePass; }
/* harmony export */ });
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54909);
/* harmony import */ var _api_balloon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81572);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39854);
/* harmony import */ var _utils_hook__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97033);
/* harmony import */ var _useBroadcastChannel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41785);





var useBundlePass = function(param) {
    var _vendor = param.vendor, vendor = _vendor === void 0 ? _constants__WEBPACK_IMPORTED_MODULE_2__/* .PAYMENT_VENDOR.standard */ .CO.standard : _vendor;
    var ref = (0,_utils_hook__WEBPACK_IMPORTED_MODULE_3__/* .useMe */ .Pi)(), me = ref.data;
    var queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQueryClient)();
    var myBundlePassQueryKey = _constants__WEBPACK_IMPORTED_MODULE_2__/* .QUERY_KEYS.PAYMENT.MY_BUNDLE_LIST */ .U7.PAYMENT.MY_BUNDLE_LIST();
    var bundlePassListQueryKey = _constants__WEBPACK_IMPORTED_MODULE_2__/* .QUERY_KEYS.PAYMENT.BUNDLE_LIST */ .U7.PAYMENT.BUNDLE_LIST(vendor);
    (0,_useBroadcastChannel__WEBPACK_IMPORTED_MODULE_4__/* .useBroadcastChannel */ .t)(_useBroadcastChannel__WEBPACK_IMPORTED_MODULE_4__/* .BROADCAST_CHANNEL.PURCHASE_DAILY_FREE_PASS */ ._.PURCHASE_DAILY_FREE_PASS, function() {
        queryClient.refetchQueries(myBundlePassQueryKey);
        queryClient.refetchQueries(bundlePassListQueryKey);
    });
    var ref1 = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(myBundlePassQueryKey, function() {
        return (0,_api_balloon__WEBPACK_IMPORTED_MODULE_1__/* .fetchMyBundlePasses */ .EC)();
    }, {
        enabled: !!me,
        onError: function(err) {
            console.log("err", err);
        }
    }), myBundlePassList = ref1.data, refetchMyBundlePassList = ref1.refetch;
    var ref2 = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(bundlePassListQueryKey, function() {
        return (0,_api_balloon__WEBPACK_IMPORTED_MODULE_1__/* .fetchStoreBundlePassItems */ .q0)({
            vendor: vendor
        });
    }, {
        enabled: !!me
    }), bundlePassList = ref2.data, refetchBundlePassList = ref2.refetch;
    var isPurchaseDailyFreePass = myBundlePassList && (myBundlePassList === null || myBundlePassList === void 0 ? void 0 : myBundlePassList.length) > 0 && myBundlePassList.some(function(v) {
        return v.bundlePassType === "story_pass" && !v.isExpired;
    }) || false;
    var myDailyFreePass = myBundlePassList && myBundlePassList.find(function(v) {
        return v.bundlePassType === "story_pass" && !v.isExpired;
    }) || null;
    var isShowDailyFreePassBanner = bundlePassList && (bundlePassList === null || bundlePassList === void 0 ? void 0 : bundlePassList.some(function(v) {
        return v.bundlePassType === "story_pass";
    })) || false;
    return {
        myBundlePassList: myBundlePassList,
        refetchMyBundlePassList: refetchMyBundlePassList,
        bundlePassList: bundlePassList,
        refetchBundlePassList: refetchBundlePassList,
        isPurchaseDailyFreePass: isPurchaseDailyFreePass,
        isShowDailyFreePassBanner: isShowDailyFreePassBanner,
        myDailyFreePass: myDailyFreePass
    };
};


/***/ })

}]);